module.exports = __webpack_public_path__ + "img/after-effects.58a28371.svg";